import Axios from "axios";
import {
  SET_ATTENDANCE_RAW_PUNCH_DATA_REPORT,
  UNSET_ATTENDANCE_RAW_PUNCH_DATA_REPORT,
} from "@/store/mutation-types";
import {
  getAttendanceRawPunchData,
} from "@/store/api";

const state = {
  attendanceRawPunchDataReport: [],
};

const getters = {
  getAttendanceRawPunchDataReport(state) {
    return state.attendanceRawPunchDataReport;
  },
};

const mutations = {
  [SET_ATTENDANCE_RAW_PUNCH_DATA_REPORT](state, data) {
    state.attendanceRawPunchDataReport = data;
  },
  [UNSET_ATTENDANCE_RAW_PUNCH_DATA_REPORT](state) {
    state.attendanceRawPunchDataReport = [];
  },
};

const actions = {
  getAttendanceRawPunchDataReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getAttendanceRawPunchData}`, { params: data })
        .then((response) => {
          commit(SET_ATTENDANCE_RAW_PUNCH_DATA_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ATTENDANCE_RAW_PUNCH_DATA_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

